import React, { useState } from "react";
import { IDesignation, IExperienceFormModel } from "./types/experience.types";
import { Button, Form, message, Steps } from "antd";
import CurrentExperience from "./utils/current-experience.view";
import PreviousExperience from "./utils/previous-experience.view";

const {Step} = Steps;

interface IExperienceViewProps {
    loading: boolean;
    goToNextTab: () => void;
    designations: IDesignation[]
    viewModel?: IExperienceFormModel;
    onSubmit: (data: IExperienceFormModel) => Promise<void>;
}

interface IExperienceSteps {
    title: string;
    fields: string[][];
    content: React.ReactNode;
}

const ExperienceView = (props: IExperienceViewProps) => {
    const [form] = Form.useForm();
    const [current, setCurrent] = useState(0);

    const steps: IExperienceSteps[] = [
        {
            title: 'Current Company',
            fields: [
                ['current', 'companyName'],
                ['current', 'designationId'],
                ['current', 'designationCode'],
                ['current', 'designationDisplayName'],
                ['current', 'employmentType'],
                ['current', 'primarySkills'],
                ['current', 'secondarySkills']
            ],
            content: <CurrentExperience form={form} designations={props.designations}/>,
        },
        {
            title: 'Previous Experience',
            fields: [['previous']],
            content: <PreviousExperience form={form} designations={props.designations}/>,
        },
    ];

    function resetCurrentStep() {
        const currentFields = steps[current].fields;
        form.resetFields(currentFields);
        message.info(`Step ${current + 1} fields reset`);
    }

    console.log("viewModel: ", props.viewModel);

    async function handleFormFinish() {
        try {
            console.log('Experience Detail Form Values:', form.getFieldsValue());
            const data: IExperienceFormModel = await form.validateFields();
            await props.onSubmit(data);
        } catch (errorInfo: any) {
            const firstError = errorInfo.errorFields?.[0];
            if (firstError) {
                const firstErrorPath = firstError.name[0];

                // find which step contains this error
                const errorStepIndex = steps.findIndex((step: IExperienceSteps) =>
                    step.fields.some((field) => field[0] === firstErrorPath)
                );

                if (errorStepIndex >= 0) {
                    setCurrent(errorStepIndex);
                }

                // scroll to the field smoothly
                setTimeout(() => {
                    form.scrollToField(firstError.name, {block: 'center'});
                }, 200);
            }
        }
    }


    return (
        <div className={"pn__employee-create__tab experience-detail"}>
            <Steps
                size="small"
                current={current}
                onChange={setCurrent}
                style={{maxWidth: '1024px', margin: '16px auto 24px'}}
                className={"pn__employee-create__steps"}
            >
                {steps.map((step, i) => (
                    <Step
                        key={i}
                        title={step.title}
                        className={"pn__employee-create__step"}
                    />
                ))}
            </Steps>

            <Form
                form={form}
                layout={'vertical'}
                className={"pn__employee-create__form experience-detail"}
                initialValues={props.viewModel}
            >
                {
                    steps.map((step: IExperienceSteps, i: number) => (
                        <div
                            key={i}
                            className={"pn__employee-create__step-section"}
                            style={{display: i === current ? 'block' : 'none'}}
                        >
                            {step.content}
                        </div>
                    ))
                }
            </Form>

            <div className={'pn__employee-create__form-actions'}>
                <Button
                    danger
                    size={'large'}
                    disabled={props.loading}
                    onClick={resetCurrentStep}
                    className={'reset-button'}
                >
                    Reset Current Step
                </Button>
                <Button
                    type="primary"
                    htmlType="submit"
                    size={'large'}
                    disabled={props.loading}
                    onClick={handleFormFinish}
                    className={'submit-button'}
                >
                    Submit Form
                </Button>
            </div>
        </div>
    )
}

export default ExperienceView;
